<template>
  <table class="table">
    <thead class="header">
      <tr class="row">
        <th
          v-for="field of fields"
          :key="field.key"
          style=""
          class="cell"
        >
          <div class="content">
            <span>
              {{ field.label }}
            </span>
            <div
              v-if="field.sortable"
              class="sort-btn"
              :class="isActiveSortIcon(field.key)"
              @click="onSort(field.key)"
            >
              <BaseIcon icon="arrow-long" class="sort-btn__arrow" />
              <BaseIcon icon="az" class="sort-btn__az" />
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) of items"
        :key="index"
      >
        <td
          v-for="(field, index) of fields"
          :key="index"
        >
          <slot
            v-if="field.slot"
            :name="field.key"
            v-bind="item"
          />
          <template v-else>
            {{ item[field.key] }}
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'AppTable',
  components: {
    BaseIcon
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: {
    sort ({ key, by }) {
      if (key && by) {
        return true
      } else {
        console.warn('Некорректные данные для генерации события sort!')
        return false
      }
    }
  },
  data () {
    return {
      sortData: {
        key: '',
        by: ''
      }
    }
  },
  methods: {
    onSort (key) {
      if (this.sortData.key === key) {
        this.sortData.key = key

        if (this.sortData.by === 'asc') {
          this.sortData.by = 'desc'
        } else {
          this.sortData.by = 'asc'
        }
      } else {
        this.sortData.key = key
        this.sortData.by = 'asc'
      }

      this.$emit('sort', this.sortData)
    },
    isActiveSortIcon (key) {
      return {
        'sort-btn_active': this.sortData.key === key,
        'sort-btn_asc': this.sortData.key === key && this.sortData.by === 'asc',
        'sort-btn_desc': this.sortData.key === key && this.sortData.by === 'desc'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

table {
  border-collapse: collapse;
  width: 100%;

  .header {
    .row {
      .cell {
        text-align: left;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
        cursor: pointer;

        .content {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .sort-btn {
            display: flex;
            align-items: center;
            color: #979797;
            margin-left: 14px;

            &_active {
              color: $brand-color;
            }

            &_asc {
              .sort-btn__arrow {
                transform: rotate(180deg);
              }
            }

            &_desc {
            }

            &__arrow {
              width: 7px;
              margin-right: 4px;
            }
            &__az {
              width: 7px;
            }
          }
        }
      }
    }
  }

  tr {
    td, th {
      padding: .5rem 20px .5rem 0;
      border-bottom: 2px solid rgba(242, 243, 247, 0.1);
    }
  }
}
</style>
